<template>
<div class="page_order page">
	<div class="list" >
		<div class="item" v-for="(item,index) in dataList" :key="index">
			<div class="item_nr">
				<div class="item_nr_r dingzhi">
					<div class="info">
						<div class="title slh_s">用户手机号：{{ item.phone }}</div>
						<div class="desc slh">定制价格：¥{{ item.price }}</div>
					</div>
				</div>
			</div>
			<div class="item_b" >
				<div class="actions">
					<div class="action" @click="clickAdd(item.customadeuser_id)">编辑</div>
					<div class="action" @click="removeFun(item.customadeuser_id,index)">删除</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 添加 -->
	<div class="bottom">
        <div class="action_add" @click="clickAdd(0)">添加</div>
    </div>
	<!-- 编辑区域 -->
	<van-overlay :show="showEdit">
		<div class="edit_wrap">
			<van-field v-model="phone" label="手机号" placeholder="请输入手机号" />
			<van-field v-model="price" label="价格" placeholder="请输入价格" />
			<div class="actions">
				<div class="action" @click="cancelFun">取消</div>
				<div class="action confirm" @click="tijiaoFun">提交</div>
			</div>
		</div>
	</van-overlay>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            custommade_id: this.$route.query.id, // 定制id
			token: null,
			dataList: [],
			showEdit: false,
			phone: "",
			price: "",
			customadeuser_id: null // 价格id
        };
    },
    created: function () {
		// console.log('this.active',this.active,typeof(this.active))
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '专属价'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getDataList()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getDataList();
        }
	},
	mounted: function(){
		
	},
    methods: {
        // 列表
		getDataList(){
			let that = this;
			let params = {
				token: that.token,
				custommade_id: that.custommade_id
			}
			that.$api.dingzhi.usermadepriceList(params).then(res=>{
				if(res.code == 200){
					if(res.result){
						that.dataList = res.result;
					}
				}else{
					that.$toast(res.message);
				}
			})
		},
		// 添加&编辑
		clickAdd(id){
			let that = this;
			that.phone = "";
			that.price = "";
			that.customadeuser_id = null;
			that.showEdit = true;
			if(id){
				that.customadeuser_id = id;
				that.getDetail(id);
			}
		},
		// 详情
		getDetail(id){
			let that = this;
			let params = {
				token: that.token,
				customadeuser_id: id
			};
			that.$api.dingzhi.usermadepriceDetail(params).then(res=>{
				if(res.code == 200){
					let info = res.result;
					that.price = info.price;
					that.phone = info.phone;
				}else{
					that.$toast(res.message)
				}
			})
		},
		// 取消
		cancelFun(){
			this.showEdit = false;
		},
		// 提交
		tijiaoFun(){
			let that = this;
			if(!that.price){
				that.$toast("请输入价格");
				return;
			};
			if(!that.phone){
				that.$toast("请输入手机号");
				return;
			}else if(!(/^1[23456789]\d{9}$/.test(that.phone))){
				that.$toast('请输入合法的手机号');
				return;
			};
			let params = {
				token: that.token,
				price: that.price,
				phone: that.phone
			}
			if(that.customadeuser_id){
				// 编辑
				params.customadeuser_id = that.customadeuser_id;
				that.$api.dingzhi.usermadepriceEdit(params).then(res=>{
					if(res.code == 200){
						that.$toast(res.message);
						that.showEdit = false;
						that.getDataList();
					}else{
						that.$toast(res.message)
					}
				})
			}else{
				// 新增
				params.custommade_id = this.custommade_id;
				that.$api.dingzhi.usermadepriceCreate(params).then(res=>{
					if(res.code == 200){
						that.$toast(res.message);
						that.showEdit = false;
						that.getDataList();
					}else{
						that.$toast(res.message)
					}
				})
			}
		},
		// 删除
		removeFun(id,index){
			let that = this;
			let params = {
				token: that.token,
				customadeuser_id: id
			};
			that.$api.dingzhi.usermadepriceRemove(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message);
					that.dataList.splice(index,1)
				}else{
					that.$toast(res.message)
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.page_order .list{
		margin-bottom: 2.06rem;
	}
	.page_order .item_nr .item_nr_r.dingzhi .desc{
		color: rgba(0,0,0,1);
	}
	.page_order .item_b{
		padding-top: 0;
	}
	.page_order .bottom{
		position: fixed;
		bottom: 0rem;
		padding: 0.53rem;
		background: #fff;
	}
	.page_order .action_add{
		width: 8.93rem;
		height: 1rem;
		background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
		border-radius: 1rem;
		line-height: 1rem;
		text-align: center;
		font-size: 0.43rem;
		color: rgba(255, 255, 255, 1);
	}
	.edit_wrap{
		position: absolute;
		background: #ffffff;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 8rem;
		padding: 0.4rem;
		border-radius: 0.4rem;
	}
	.edit_wrap .actions{
		justify-content: space-around;
	}
	.edit_wrap .van-cell::after{
		left: 0 !important;
	}
	/deep/.edit_wrap .van-field__label{
		width: 1.2rem !important;
	}
	.edit_wrap .van-cell{
		padding: 0.2rem 0;
	}
	.edit_wrap .actions .action{
		flex: 1;
		width: auto;
		height: auto;
		border: 0 none;
	}
</style>
